import React from 'react';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import Container from 'components/layout/Container';
import ReviewsSwiper from 'components/ui/ReviewsSwiper';

import './reviews.scss';

const Reviews = () => {
  return (
    <section className="reviews">
      <Container>
        <Title
          extraClassName="reviews__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
          color={TitleColor.black}
        >
          Отзывы наших клиентов
        </Title>

        <ReviewsSwiper />
      </Container>
    </section>
  );
};

export default Reviews;
